Plus.createCookie = function (name, value, hours) {
  if (hours) {
    var date = new Date()
    date.setTime(date.getTime() + hours * 3600 * 1000)
    var expires = '; expires=' + date.toUTCString()
  } else {
    var expires = ''
  }

  document.cookie = name + '=' + value + expires + '; path=/'
}

Plus.readCookie = function (name) {
  var nameEQ = name + '=',
    ca = document.cookie.split(';')

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
  }

  return null
}

Plus.deleteCookie = function (name) {
  document.cookie =
    name + '=false; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'
}

Plus.freeGift = function () {}

Plus.freeGift.settings = {
  modalTrigger: document.querySelector('#plus-free-gift__trigger'),
  promptedCookieName: 'plus-free-gift-prompted',
  addedCookieName: 'plus-free-gift-added',
  promptedCookie: Plus.readCookie('plus-free-gift-prompted'),
  addedCookie: Plus.readCookie('plus-free-gift-added'),
  cookieExpiry: 1,
  cartBanner: document.querySelector('.plus-free-gift-modal__cart-banner'),
  cartBannerButton: document.querySelector(
    '.plus-free-gift-modal__cart-banner__content-button__text'
  ),
  modalCancelButton: document.querySelector('.plus-free-gift-modal__cancel'),
  modalAddToCart: document.querySelector('.plus-free-gift-modal__add-to-cart'),
}

document.addEventListener('DOMContentLoaded', async function () {
  await Plus.freeGift.checkCart()
  Plus.freeGift.init(Plus.freeGift.settings)
})

Plus.freeGift.init = function (settings) {
  // Initialize the modal
  Plus.freeGift.modalInit(
    settings.modalTrigger,
    settings.promptedCookieName,
    settings.cookieExpiry
  )

  if (Plus.cartQualifies) {
    // Unless all gift item in the cart, delete the added cookie and show the banner
    if (Plus.plusAllGiftsInCart == false) {
      Plus.deleteCookie('plus-free-gift-added')
      settings.cartBanner.style.display = 'block'
    }

    // If we do not have all gift products in the cart, show the free gift banner
    // if (!settings.addedCookie) {
    //   settings.cartBanner.style.display = 'block'
    // }

    // If we haven't seen the modal before, show it
    // if (!settings.promptedCookie) {
    //   Plus.triggerClick(null, settings.modalTrigger)
    // }
  }

  //Open the modal if the cart banner is clicked
  document.querySelector(
    '.plus-free-gift-modal__cart-banner__content-button__text'
  ) &&
    document
      .querySelector('.plus-free-gift-modal__cart-banner__content-button__text')
      .addEventListener('click', function () {
        document.getElementById('plus-free-gift-modal').classList.add('open')
      })

  // Add to cart settings
  var args = {
    promptedCookieName: settings.promptedCookieName,
    addedCookieName: settings.addedCookieName,
    cookieExpiry: settings.cookieExpiry,
  }

  // Check status [NEW]
  Plus.freeGift.checkStatus = async function () {
    await Plus.freeGift.checkCart()

    Plus.freeGift.modalInit(
      settings.modalTrigger,
      settings.promptedCookieName,
      settings.cookieExpiry
    )

    if (Plus.cartQualifies) {
      // Unless all gift item in the cart, delete the added cookie and show the banner
      if (Plus.plusAllGiftsInCart == false) {
        Plus.deleteCookie('plus-free-gift-added')
        document.querySelector(
          '.plus-free-gift-modal__cart-banner'
        ).style.display = 'block'
      }

      // If we do not have all gift products in the cart, show the free gift banner
      // if (settings.addedCookie !== 'true') {
      //   document.querySelector(
      //     '.plus-free-gift-modal__cart-banner'
      //   ).style.display = 'block'
      // }
    }

    document.querySelector(
      '.plus-free-gift-modal__cart-banner__content-button__text'
    ) &&
      document
        .querySelector(
          '.plus-free-gift-modal__cart-banner__content-button__text'
        )
        .addEventListener('click', function () {
          document.getElementById('plus-free-gift-modal').classList.add('open')
        })
  }

  // Remove modal items if there's one in the cart already
  Plus.modalEdit = function (e, handler, args) {
    fetch('/cart.js', {
      method: 'GET',
    })
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        for (const product of document.querySelectorAll(
          '.plus-free-gift-modal__product'
        )) {
          let plusGiftGridItem = product
          let plusVariant = plusGiftGridItem
            .querySelector('.plus-free-gift-modal__product-title')
            .getAttribute('data-plus-variant-id')
          for (const plusItem in data.items) {
            if (data.items[plusItem]['variant_id'] == plusVariant) {
              plusGiftGridItem.remove()
            }
          }
        }
      })
      .then((data) => {
        if (typeof args !== 'undefined') {
          handler(e, args)
        } else {
          handler()
        }
      })
      .catch((error) => {
        console.error('Error:', error)
      })
  }

  // Add item to cart
  Plus.handleClick(settings.modalAddToCart, Plus.freeGift.addToCart, args)
}

Plus.fetchCart = async function () {
  return await fetch('/cart.js')
    .then((response) => response.json())
    .then((response) => {
      return response
    })
}

Plus.freeGift.modalInit = async function (
  modalTrigger,
  promptedCookieName,
  cookieExpiry
) {
  var modal = document.getElementById('plus-free-gift-modal')
  const cartItems = await Plus.fetchCart()
  const activeProducts = []
  document.querySelector('.plus-free-gift-modal__products').innerHTML = ''

  for (const tag of window.plusSetTagArray) {
    activeProducts.push(
      window.collection.filter((v) => v.tags.includes(tag))[0]
    )
  }
  console.log(activeProducts)
  for (const product of activeProducts) {
    if (!cartItems.items.some((e) => e.title === product.title)) {
      const listItem = document
        .querySelector('div[data-gift-template]')
        .cloneNode(true)
      listItem.querySelector('img').setAttribute('src', product.featured_image)
      listItem.querySelector('img').setAttribute('alt', product.title)
      listItem
        .querySelector('.plus-free-gift-modal__product-title')
        .setAttribute('data-plus-variant-id', product.variants[0].id)
      listItem.querySelector('.plus-free-gift-modal__product-title').innerText =
        product.title
      document
        .querySelector('.plus-free-gift-modal__products')
        .appendChild(listItem.querySelector('.plus-free-gift-modal__product'))
    }
  }
  var exits = modal.querySelectorAll('.modal-exit')
  exits.forEach(function (exit) {
    exit.addEventListener('click', function (event) {
      event.preventDefault()
      Plus.createCookie(promptedCookieName, true, cookieExpiry)
      modal.classList.remove('open')
    })
  })
}

Plus.handleClick = function (el, handler, args) {
  el &&
    el.addEventListener('click', function (e) {
      e.preventDefault()

      Plus.modalEdit(e, handler, args)
    })
}

Plus.triggerClick = function (e, el) {
  el.click()
}

Plus.freeGift.addToCart = function (e, args) {
  let plusVariantIds = []

  for (const pid of document.querySelectorAll('div[data-plus-variant-id]')) {
    if (Number(pid.getAttribute('data-plus-variant-id')) > 0) {
      plusVariantIds.push(Number(pid.getAttribute('data-plus-variant-id')))
    }
  }
  callback = Plus.freeGift.addToCartCallback

  Plus.AddToCart(plusVariantIds, callback, args)
  e.stopPropagation()
}

Plus.freeGift.addToCartCallback = function (args) {
  // Create cookies so the modal/banner don't show once they've added an item
  Plus.createCookie(args.promptedCookieName, true, args.cookieExpiry)
  Plus.createCookie(args.addedCookieName, true, args.cookieExpiry)

  // Close the modal and refresh the page to show new item in the cart
  document.getElementById('plus-free-gift-modal').classList.remove('open')
}

Plus.freeGift.checkCart = async function () {
  var giftCount = 0
  window.plusSetTagArray = []
  await fetch('/cart.js')
    .then((data) => {
      return data.json()
    })
    .then(async (data) => {
      const filteredItems = data.items.filter((value, index, self) => {
        return (
          self.findIndex((v) => v.variant_id === value.variant_id) === index
        )
      })
      for (const item of filteredItems) {
        if (item.properties) {
          for (const [key, value] of Object.entries(item.properties)) {
            if (key == '_plus_free_gift') {
              giftCount++
            }
          }
        }
        await fetch(`${shopUrl}/products/${item.handle}.js`)
          .then((pr) => {
            return pr.json()
          })
          .then((pr) => {
            for (const tag of pr.tags) {
              if (tag.indexOf('set_') > -1) {
                window.plusSetTagArray.push(tag)
              }
            }
          })
      }
      window.plusSetTagArray = window.plusSetTagArray.filter(
        (v, i, a) => a.indexOf(v) === i
      )
      if (window.plusSetTagArray.length > 0) {
        Plus.cartQualifies = true
      }
      Plus.plusAllGiftsInCart = giftCount === window.plusSetTagArray.length
    })
}

Plus.AddToCart = function (plusVariantIdArray, callback, args) {
  const cart =
    document.querySelector('cart-notification') ||
    document.querySelector('cart-drawer')
  const items = []

  const formData = new FormData()

  var count = 0
  for (const product of plusVariantIdArray) {
    formData.append(`items[${count}][id]`, Number(product))
    formData.append(`items[${count}][quantity]`, 1)
    formData.append(`items[${count}][properties[_plus_free_gift]]`, 'true')
    count++
  }

  const config = fetchConfig('javascript')
  config.headers['X-Requested-With'] = 'XMLHttpRequest'
  delete config.headers['Content-Type']

  if (cart) {
    formData.append(
      'sections',
      cart.getSectionsToRender().map((section) => section.id)
    )
    formData.append('sections_url', window.location.pathname)
    cart.setActiveElement(document.activeElement)
  }
  config.body = formData

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then(async (response) => {
      await Plus.freeGift.checkStatus()
      cart.renderContents(response)
    })
    .catch((e) => {
      console.error(e)
    })
    .finally(() => {
      if (cart && cart.classList.contains('is-empty')) {
        cart.classList.remove('is-empty')
      }
      Plus.createCookie('plus-free-gift-prompted', true, 1)
      // Plus.createCookie('plus-free-gift-added', true, 1)
      Plus.freeGift.checkStatus()
      document.querySelector('.gift-modal').classList.remove('open')
    })
}
